module.exports = __webpack_public_path__ + "static/media/notes.9244e394.svg";